export default "__VITE_ASSET__BCtnn4Ak__"